import React, { useEffect, useState } from 'react'
import robotImg from '../../images/robotImg.png'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

const PopupThree = ({ formData, setFormData, onClose, onNext, handleSaveOnDB }) => {
  const [selected, setSelected] = useState(formData.engage || "yes");
  const [isFirst, setIsFirst] = useState(true);
  const navigate = useNavigate();
  const [itemType, setItemType] = useState("");
  const handleRadioChange = (value) => {
    setSelected(value)
    setFormData(prev => ({
      ...prev,
      engage: value
    }))
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSelectChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleStartButtonClick = (type) => {
    // console.log(`Starting with: ${type}`);
    setItemType(type);
    setIsFirst(false);
    // You can add functionality here for what happens when each button is clicked
  }

  const handleSaveAndNext = () => {
    // Save the form data and move to next step
    if (formData?.engage === "yes") {
      return handleSaveOnDB({
        email: formData?.email || "",
        phoneNumber: formData?.phoneNumber || "",
        preferedDay: formData?.preferedDay || "",
        preferedTime: formData?.preferedTime || "",
        engage: formData?.engage || "yes",
      });
    }
    toast.success("Data has been saved successfully");
    onNext();
  };

  useEffect(() => {
    switch(itemType) {
      case "POST REVENUE": 
           navigate("/postnewincome");
           break;
      case "POST EXPENSES": 
           navigate("/newexpense");
           break;
      case "SETUP BUDGETS": 
           navigate("/budget-tracker");
           break;   
      case "SETUP PROJECTS": 
           navigate("/project-budget-setup");
           break;  
      case "CONNECT CALENDARS": 
           navigate("/connectCalender");
           break;               
      default: !isFirst && toast.success("No item has been matched successfully");     
    }
  }, [itemType]);

  return (
    <div className="popup_overlay_po" onClick={onClose}>
      <div
        className="popup_container_po"
        onClick={(e) => e.stopPropagation()}
      >

        <div className="popup_content_po">

          <div className="popup_left_po">
            <div className="mob_rob_wrp">
              <h2>
                Let's Help You Engage for Instant Benefits!
              </h2>
              <div className="robo_img_wrp">
                <img src={robotImg} alt="" />
              </div>
            </div>

            <div className="step_pill_po">Step 3 : Engage</div>

            <div className="checked_wrapper_co">

              <label className="checked_option_co">
                <input
                  type="radio"
                  name="contact"
                  value="yes"
                  checked={selected === "yes"}
                  onChange={() => handleRadioChange("yes")}
                />
                <span className="radio_ui_co"></span>
                <span className="label_text_co">
                  Yes, Please Have a Product Specialist Contact Me!
                </span>
              </label>


              <label className="checked_option_co">
                <input
                  type="radio"
                  name="contact"
                  value="no"
                  checked={selected === "no"}
                  onChange={() => handleRadioChange("no")}
                />
                <span className="radio_ui_co"></span>
                <span className="label_text_co">
                  No, I'm Ready to Begin Using!
                </span>
              </label>


              <div className="conditional_box_co">
                {selected === "yes" && (
                  <div className="form_wrapper_co">

                    <div className="form_group_co">
                      <label className="form_label_co">Email:</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        className="form_input_co"
                        value={formData.email || ""}
                        onChange={handleInputChange}
                      />
                    </div>


                    <div className="form_group_co">
                      <label className="form_label_co">Phone:</label>
                      <input
                        type="tel"
                        name="phoneNumber"
                        placeholder="Enter your phone number"
                        className="form_input_co"
                        value={formData.phoneNumber || ""}
                        onChange={handleInputChange}
                      />
                    </div>


                    <div className="form_group_co">
                      <label className="form_label_co">Preferred Day:</label>
                      <select
                        className="form_input_co"
                        name="preferedDay"
                        value={formData.preferedDay || ""}
                        onChange={handleSelectChange}
                      >
                        <option value="">Select</option>
                        <option value="Monday">Monday</option>
                        <option value="Tuesday">Tuesday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="Thursday">Thursday</option>
                        <option value="Friday">Friday</option>
                      </select>
                    </div>


                    <div className="form_group_co">
                      <label className="form_label_co">Preferred Time:</label>
                      <select
                        className="form_input_co"
                        name="preferedTime"
                        value={formData.preferedTime || ""}
                        onChange={handleSelectChange}
                      >
                        <option value="">Select</option>
                        <option value="Morning">Morning</option>
                        <option value="Afternoon">Afternoon</option>
                        <option value="Evening">Evening</option>
                      </select>
                    </div>
                  </div>
                )}

                {selected === "no" && (
                  <div className="start_wrap_co">
                    <p className="start_title_co">Where Would You Like to Start?</p>

                    <div className="start_list_co">
                      <button
                        className="start_btn_co"
                        onClick={() => handleStartButtonClick("POST REVENUE")}
                      >
                        POST REVENUE
                      </button>
                      <button
                        className="start_btn_co"
                        onClick={() => handleStartButtonClick("POST EXPENSES")}
                      >
                        POST EXPENSES
                      </button>
                      <button
                        className="start_btn_co"
                        onClick={() => handleStartButtonClick("SETUP BUDGETS")}
                      >
                        SETUP BUDGETS
                      </button>
                      <button
                        className="start_btn_co"
                        onClick={() => handleStartButtonClick("SETUP PROJECTS")}
                      >
                        SETUP PROJECTS
                      </button>
                      <button
                        className="start_btn_co"
                        onClick={() => handleStartButtonClick("CONNECT CALENDARS")}
                      >
                        CONNECT CALENDARS
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <button className="save_next_po" onClick={handleSaveAndNext}>
              SAVE & GO
            </button>

            <p className="skip_po" onClick={onNext}>
              Skip to next
            </p>
          </div>
        </div>
      </div>
      <div className="popup_right_po">
        <img
          src={robotImg}
          alt="robot"
          className="robot_img_po"
        />
      </div>
    </div>
  )
}

export default PopupThree;